import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_atlas-shield-hub/artifacts/0efgybb9_Instalros_logo-removebg-preview.png";

export const Logo = ({ size = 36, className = "" }) => (
  <span className={className} data-testid="instalros-logo">
    <img
      src={LOGO_URL}
      alt="IN|STALROS"
      style={{ height: size, width: "auto", display: "block" }}
    />
  </span>
);

export default Logo;
